import GoCardless from './GoCardless'

export default GoCardless;
